module.exports = __webpack_public_path__ + "assets/final-type-7.png";